import React, { useState, useEffect } from "react";
import { Main, Content, SubContent } from "../../../components/Layout";
import { ModalAddTask, ModalUpload, ModalBudget } from "../../../components/Modal";
import modalStyle from "../../../components/Modal/style.module.css";
import api from "../../../services/api";
import { Row, Col, Form, Modal } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Checkbox from "../../../components/Checkbox";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import IcX from "../../../components/Svg/IcX";
import IcFile from "../../../components/Svg/IcFile";
import Slct from "../../../components/Slct";
import styleButton from "../../../components/Button/Button.module.css";
import styles from "../Business.module.css";
import CommentSingle from "../../../components/Comments/Single";
import WriteComment from "../../../components/Comments/WriteComment";
import Loading from "../../../components/Loading";
import { ModalConfirm } from "../../../components/Modal";
import getCommercial from "../../../util/getCommercial";
import useWrapper from "../../../hooks/useWrapper";
import useFormat from "../../../hooks/utils/useFormat";
import FileDisplay from "../../../components/FileDisplay";
import CalendarBig from "../../../components/CalendarBig";
import Button from "../../../components/Button";
import BudgetsList from "../../../components/BudgetsList";
import EmptyError from "../../../components/EmptyError";
import ActivityLogs from "../../../components/ActivityLogs";

export default function NewBudget() {
  const { formatDate, formatPhone, sortObject, stringToDate } = useFormat();

  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleShow2 = () => setShow2(true);
  const { businessId } = useParams();

  const [itemId, setItemId] = useState();
  function readEvent(id) {
    setItemId(id);
    setModalShow(true);
  }

  const navigate = useNavigate();

  const { setbreadcrumb, token, config, me } = useWrapper();
  const permissions = JSON.parse(me.permissions);

  const [loadingPage, setLoadingPage] = useState(true);

  const [schedule, setSchedule] = useState([]);
  const [activity, setActivity] = useState([]);
  const [steps, setSteps] = useState([]);
  const [messageItem, setMessageItem] = useState("");

  const [uploadLoading, setUploadLoading] = useState(false);
  const uploadFile = async file => {
    if (!modalUploadText.contract || (modalUploadText.contract && budgets?.length > 0)) {
      try {
        setUploadLoading(true);
        let bodyFormData = new FormData();
        bodyFormData.append("file", file);

        const { data: _file } = await api.post("files", bodyFormData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            contract: modalUploadText.contract,
            commercial: businessId,
            publico: filePermission,
          },
        });
        await api.put(
          `commercial/${businessId}`,
          {
            files: [_file.id],
            is_class: commercial.is_class || modalUploadText.contract,
            ...(!!commercial.became_class ? { became_class: commercial.became_class } : { became_class: new Date() }),
          },
          config,
        );
        await api.post(
          "activity",
          {
            message: modalUploadText.contract ? `Contrato fechado!` : `Upload do arquivo <b>${_file.name}</b> efetuado`,
            user_id: me.id,
            commercial_id: businessId,
            type: "act",
          },
          config,
        );
      } catch (__error) {
        console.log("__error", __error);
        setUploadLoading(false);
        toast.error("Não foi possível realizar o upload do arquivo.");
      } finally {
        toast.success(modalUploadText.contract ? "Turma criada com sucesso!" : "Anexo feito com sucesso!");
        setModalUploadText({ title: null, text: null });
        setUploadLoading(false);
        setReload(!reload);
        modalUploadText.contract && navigate(`/groups/${businessId}/registrationdata`);
      }
    } else {
      toast.error("A turma só pode ser cadastrada após a aprovação do orçamento!");
    }
  };

  const [modalUploadText, setModalUploadText] = useState({
    title: null,
    text: null,
  });

  const [downloadInfos, setDownloadInfos] = useState({ modalOpen: false });
  const completeDownload = () => {
    window.open(downloadInfos.url);
    setDownloadInfos({ modalOpen: false });
  };

  const [modalShow, setModalShow] = useState(false);
  const [reload, setReload] = useState(false);
  function reloadCalendar() {
    setReload(!reload);
  }

  let statusFeed = [];

  async function loadSchedule() {
    try {
      const { data: _schedule } = await api.get(
        "calendars",
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            commercial_id: businessId,
          },
        },
        config,
      );
      setSchedule(_schedule);
    } catch (__error) {}
  }

  async function saveMessage() {
    try {
      await api.post(
        "activity",
        {
          message: messageItem,
          user_id: me.id,
          commercial_id: businessId,
          type: "msg",
        },
        config,
      );

      setMessageItem("");
      loadActivity(businessId);
      toast.success("Comentário salvo com sucesso!");
    } catch (error) {
      toast.error("Falha ao salvar os dados.");
    }
  }
  async function cancelCommercial() {
    try {
      await api.put(
        `commercial/${businessId}`,
        {
          over_price: commercial?.over_price,
          obs: commercial?.obs,
          reason: commercial?.reason,
          reason_obs: commercial?.reason_obs,
          step_id: null,
          status: "trade-canceled",
          ...(commercial?.concurrent && { concurrent_id: commercial?.concurrent }),
        },
        config,
      );

      navigate(`/business`);

      toast.success("Negociação cancelada com sucesso!");
    } catch (error) {
      toast.error("Falha ao cancelar negociação.");
    }
  }

  function newBudgetRedirect(hash = "") {
    navigate(`/business/newbudget/${businessId}${hash}`);
  }

  async function loadActivity(itemId) {
    setActivity([]);
    const { data: activity_reponse } = await api.get(`activity?commercial_id=${itemId}&paginate=false`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    setActivity(activity_reponse);
  }

  const [commercial, setcommercial] = useState();
  useEffect(() => {
    if (commercial) {
      if (commercial.is_class) {
        navigate(`/groups/${commercial.id}/registrationdata`);
      }
    }
  }, [commercial]);

  useEffect(() => {
    (async function () {
      try {
        const _commercial = await getCommercial(businessId);
        setcommercial(_commercial);
        setseller(_commercial.seller);

        const { data: _steps } = await api.get("steps", config);
        setSteps(_steps);

        setLoadingPage(false);
      } catch (__error) {
        console.log("__error", __error);
        __error?.response?.status === 401 && navigate("/no-permission");
      }
    })();
  }, [reload]);

  const [users, setusers] = useState();
  const [seller, setseller] = useState();
  useEffect(() => {
    if (commercial) {
      (async function () {
        const _users = await api.get(`users?paginate=false`, config);
        setusers(
          _users?.data?.map(e => ({
            value: e.id,
            label: e.username,
          })),
        );
      })();
    }
  }, [commercial]);

  useEffect(() => {
    loadSchedule();
    loadActivity(businessId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const [concurrents, setconcurrents] = useState([]);
  useEffect(() => {
    api.get("concurrent?active=1", config).then(response => {
      setconcurrents(
        response.data.map(e => ({
          value: e.id,
          label: e.name,
        })),
      );
    });
  }, []);

  const handlemessage = event => {
    setMessageItem(event.target.value);
  };

  const [filePermission, setfilePermission] = useState("publico");

  useEffect(() => {
    if (commercial?.institution?.name) {
      setbreadcrumb([
        { label: "Comercial", url: "/business" },
        { label: commercial?.institution?.name, title: true },
      ]);
    }
  }, [commercial]);

  const [budgets, setbudgets] = useState([]);
  useEffect(() => {
    (async () => {
      if (!!commercial?.id) {
        try {
          const { data: _budgets } = await api.get(`budget-colection?commercial_id=${commercial?.id}`, config);

          sortObject({
            array: _budgets,
            key: "updated_at",
            type: "date",
          });
          sortObject({
            array: _budgets,
            key: "main",
            type: "boolean",
          });
          setbudgets(_budgets);
        } catch (__err) {
          console.log("__err", __err);
          toast.error("Problema ao carregar os orçamentos.");
        }
      }
    })();
  }, [commercial?.id]);

  return (
    <Main>
      {permissions.commercial.reading && (
        <>
          <ModalBudget
            show={show2}
            title="Outras Versões"
            closeModal={() => {
              setShow2(false);
            }}
            budgets={commercial?.budget?.data || []}
            setReload={setReload}
            reload={reload}
            newBudget={true}
          />
          <ModalAddTask
            reload={reload}
            reloadCalendar={reloadCalendar}
            itemId={itemId}
            turmaId={businessId}
            turmaDisabled={true}
            show={modalShow}
            onHide={() => setModalShow(false)}
          />
          <ModalUpload
            reload={reload}
            reloadCalendar={reloadCalendar}
            show={!!modalUploadText.title}
            closeModal={() => setModalUploadText({ title: null, text: null })}
            title={modalUploadText.title}
            pretext={modalUploadText.text}
            uploadCB={uploadFile}
            loading={uploadLoading}
            commercial_file={true}
            filePermission={modalUploadText.permission || filePermission}
            setfilePermission={setfilePermission}
          />

          <ModalConfirm
            show={downloadInfos.modalOpen}
            title="Download"
            text={`Deseja efetuar o download do arquivo ${downloadInfos.fileName}?`}
            confirm={completeDownload}
            closeModal={() => {
              setDownloadInfos({ modalOpen: false });
            }}
            colorScheme="secondary"
          />
        </>
      )}
      {!loadingPage ? (
        <Content noBG="true">
          <SubContent className="mb-4">
            <Row>
              <Col>
                <h2 className="mini-title">{commercial?.label}</h2>
                <p className="small-label">
                  <span>
                    Expectativa de <b>{commercial?.total_trainees}</b> Formandos
                  </span>
                </p>
              </Col>
              <Col sm={6} className="text-end">
                <Button color="error_ghost" onClick={handleShow}>
                  Encerrar Negociação
                </Button>
                {commercial?.step_id === 4 ? (
                  <Button
                    color="success_ghost"
                    onClick={() => {
                      const _event_wo_date = budgets
                        ?.find(__budget => !!__budget.main)
                        ?.colectionsEventDates?.some(__event => !__event.due_date);
                      if (!_event_wo_date) {
                        setModalUploadText({
                          title: "Anexar Contrato",
                          text: "Ficamos felizes que mais uma turma está entrando na casa! E para oficializar esta relação, anexe aqui o contrato combinado e vigente para compor a pasta de aquivos da turma!",
                          contract: 1,
                          permission: "publico",
                        });
                      } else {
                        toast.error("Existem eventos sem data definida.");
                      }
                    }}
                  >
                    Iniciar Cadastro da Turma
                  </Button>
                ) : (
                  <Button
                    color="success_ghost"
                    onClick={() => {
                      navigate(`/business/budget/${businessId}/new`);
                    }}
                  >
                    Novo Orçamento
                  </Button>
                )}
              </Col>
            </Row>
            <Row>
              <Col>
                <Modal
                  show={show}
                  onHide={handleClose}
                  size="lg"
                  aria-labelledby="example-modal-sizes-title-lg"
                  centered
                >
                  <Modal.Header>
                    <Modal.Title>Encerrando uma Negociação</Modal.Title>
                    <button className={modalStyle.closeModal} onClick={handleClose}>
                      <IcX />
                    </button>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="sub-title mb-3">
                      Ao encerrar uma negociação, a turma em questão será declarada como perdida e será retirada do
                      comercial da empresa. Para melhorar desempenhos futuros, precisamos que você nos conte um pouco
                      mais sobre o encerramento, ok?
                    </p>
                    <h3 className="form-title mb-2">Qual o principal motivo desse encerramento?</h3>
                    <Row className="mb-2">
                      <Col>
                        <Slct
                          value={commercial?.reason || ""}
                          options={[
                            { value: "concorrencia", label: "Fechou com a concorrência" },
                            { value: "outro", label: "Outro" },
                          ]}
                          placeholder="..."
                          onChange={e => {
                            setcommercial({
                              ...commercial,
                              reason: e.value,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    {commercial?.reason === "concorrencia" && (
                      <Row>
                        <Col>
                          <Form.Group className="lince-input">
                            <Slct
                              value={commercial?.concurrent || ""}
                              options={concurrents}
                              placeholder="..."
                              onChange={e => {
                                setcommercial({
                                  ...commercial,
                                  concurrent: e.value,
                                });
                              }}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                    {commercial?.reason === "outro" && (
                      <Row>
                        <div className="inner-page__break-arrow"></div>
                        <Col>
                          <Form.Group className="lince-input">
                            <div className="lince-input__text">
                              <Form.Control
                                required
                                type="text"
                                value={commercial?.reason_obs}
                                onChange={e => {
                                  setcommercial({
                                    ...commercial,
                                    reason_obs: e.target.value,
                                  });
                                }}
                                name="reason_obs"
                                placeholder="Insira o motivo"
                              />
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    )}
                    <Form.Group className="lince-input ckeckModal">
                      <Form.Check.Label>
                        <Checkbox
                          name="over_price"
                          checked={commercial?.over_price}
                          onChange={e => {
                            setcommercial({
                              ...commercial,
                              over_price: e.target.checked,
                            });
                          }}
                        />
                        <span className="ml-2">
                          Marque esta opção se os valores do orçamento também foram motivo para esse encerramento.
                        </span>
                      </Form.Check.Label>
                    </Form.Group>
                    <h3 className="mt-4 mb-2 form-title">
                      Aconteceu mais alguma coisa que seja interessante registrar?
                    </h3>
                    <textarea
                      name="obs"
                      value={commercial?.obs}
                      onChange={e => {
                        setcommercial({
                          ...commercial,
                          obs: e.target.value,
                        });
                      }}
                      placeholder="Adicionar comentário"
                      cols="30"
                      rows="5"
                    ></textarea>
                  </Modal.Body>
                  <Modal.Footer>
                    <div className="text-right">
                      <button onClick={cancelCommercial} className={styleButton.button_error}>
                        Encerrar Negociação
                      </button>
                    </div>
                  </Modal.Footer>
                </Modal>
              </Col>
            </Row>
            <Row>
              <Col>
                {steps.length > 0 &&
                  steps.forEach(item => {
                    statusFeed.push(
                      <span className={commercial?.step_id >= item.order ? "active" : ""}>{item.name}</span>,
                    );
                  })}
                <div className={styles.statusFeed}>{statusFeed}</div>
              </Col>
            </Row>
          </SubContent>

          <Row>
            <Col sm={4}>
              <SubContent className="mb-4">
                <div className="text-center position-relative">
                  <p className={styles.statusTitle}>
                    <span>Orçamentos</span>
                  </p>
                </div>
                <div className="text-end">
                  <Button onClick={() => navigate(`/business/budget/${businessId}/new`)} size="sm">
                    Novo Orçamento
                  </Button>
                </div>
                {budgets.length > 0 ? (
                  <BudgetsList budgets={budgets} />
                ) : (
                  <EmptyError msg={<p>Nenhum orçamento cadastrado.</p>} />
                )}
              </SubContent>
              {!!commercial?.budget.main && (
                <SubContent className="mb-4">
                  <div className="bloco dadosFeed heightAuto">
                    <div className="item">
                      <div className="text-center position-relative">
                        <p className={styles.statusTitle}>
                          <span>Orçamentos (Legado)</span>
                        </p>
                      </div>
                      {!!commercial?.budget.main ? (
                        <>
                          <div className={styles.files}>
                            <p className="m-0 mb-2">
                              <b>Versão Principal</b>
                            </p>
                            <div className={styles.download}>
                              <div className={`mr-2 text-center ${styles.icon}`} style={{ width: "29px" }}>
                                <span className="w-100 d-block" style={{ width: "29px" }}>
                                  doc
                                </span>
                                <IcFile />
                              </div>
                              <div className={`ml-3 ${styles.desc}`}>
                                <p className="m-0">
                                  {commercial?.budget?.selected?.name} - {commercial?.budget?.selected?.id}
                                </p>
                              </div>
                              <div className="d-flex flex-grow-1 flex-column ml-3">
                                <NavLink
                                  to={`/business/newbudget/${businessId}/${commercial?.budget?.selected?.id}`}
                                  className={styleButton.button_mini_ghost}
                                >
                                  <span>Ver</span>
                                </NavLink>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex">
                            <button
                              className={`${styleButton.button_mini_ghost} d-flex flex-grow-1`}
                              onClick={handleShow2}
                            >
                              Ver outras versões
                            </button>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="d-flex">
                            <button
                              className={`${styleButton.button_mini_ghost} d-flex flex-grow-1`}
                              onClick={() => newBudgetRedirect()}
                            >
                              <span>Novo Orçamento</span>
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </SubContent>
              )}
              <SubContent>
                <div className="text-center position-relative">
                  <p className={styles.statusTitle}>
                    <span>Dados da Turma</span>
                  </p>
                </div>
                <div className={`${styles.dadosFeed}`}>
                  {commercial?.comission.length > 0 && (
                    <>
                      <div className="d-flex justify-content-start align-items-center mb-2 mt-4">
                        <h3 className="mini-title">Dados da Comissão</h3>
                      </div>
                      {commercial?.comission.map((__member, i) => (
                        <div className={styles.miniGroup}>
                          <p className={styles.miniTitle}>Membro {i + 1}</p>
                          <p>{__member.name}</p>
                          <p>{__member.email}</p>
                          <p>{formatPhone(__member.cell)}</p>
                        </div>
                      ))}
                    </>
                  )}
                  <div className="d-flex justify-content-start align-items-center mb-2 mt-4">
                    <h3 className="mini-title">Dados Contratuais</h3>
                  </div>
                  <div>
                    <div className={styles.miniGroup}>
                      <p className={styles.miniTitle}>Convites</p>
                      <p>{commercial?.invites_trainees}</p>
                    </div>
                    <div className={styles.miniGroup}>
                      <p className={styles.miniTitle}>Ingressos</p>
                      <p>{commercial?.ticket_trainees}</p>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start align-items-center mb-2 mt-4">
                    <h3 className="mini-title">Vendedor</h3>
                  </div>
                  <Slct
                    value={seller}
                    options={users || []}
                    placeholder="..."
                    onChange={e => {
                      (async function () {
                        const { data: _commercial } = await api.put(
                          `commercial/${businessId}`,
                          { user_id: e.value },
                          config,
                        );
                        let _seller = {
                          id: e,
                          name: users?.find(__user => __user.value === e.value)?.label,
                        };
                        await api.post(
                          "activity",
                          {
                            message: `Vendedor modificado para ${_seller.name}`,
                            user_id: me.id,
                            commercial_id: businessId,
                            type: "act",
                          },
                          config,
                        );
                        setReload(!reload);
                        toast.success("Vendedor atualizado com sucesso!");
                      })();
                      setseller(e.value);
                    }}
                  />
                </div>
                <div className="divisor mt-4 mb-4"></div>
                <div>
                  <button
                    onClick={() => navigate(`/business/edit/${businessId}#commercial`)}
                    type="button"
                    className={`${styleButton.button_mini_ghost} mr-3`}
                  >
                    <span>Editar Dados/Pacotes</span>
                  </button>
                </div>
              </SubContent>
            </Col>
            <Col>
              <div className="bloco">
                <div className="timeLineFeed">
                  <SubContent className="mb-4">
                    <div className="text-center position-relative">
                      <p className={styles.statusTitle}>
                        <span>Arquivos</span>
                      </p>
                      <Row className="mb-n4">
                        <Col className="sm-12">
                          <FileDisplay
                            files={commercial?.files || []}
                            commercial_id={commercial?.id}
                            reload={() => {
                              setReload(!reload);
                            }}
                            loading={!commercial}
                          />
                        </Col>
                      </Row>
                    </div>
                  </SubContent>
                  <SubContent className="mb-4">
                    <div className="text-center position-relative">
                      <p className={styles.statusTitle}>
                        <span>Calendário</span>
                      </p>
                    </div>
                    <CalendarBig
                      reload={reload}
                      setreload={setReload}
                      events={
                        schedule?.map(__event => {
                          const _date = stringToDate(__event.date_start);
                          return {
                            start: _date,
                            end: _date,
                            all_day: !!__event.all_day,
                            title: __event.title,
                            status: __event.status,
                            done: __event.done,
                            id: __event.id,
                          };
                        }) || []
                      }
                      onSelectEvent={__ev => {
                        readEvent(__ev.id, commercial.id);
                      }}
                      loading={false}
                    />
                  </SubContent>
                  <SubContent>
                    <ActivityLogs
                      activity={activity}
                      messageItem={messageItem}
                      handlemessage={handlemessage}
                      saveMessage={saveMessage}
                    />
                  </SubContent>
                </div>
              </div>
            </Col>
          </Row>
        </Content>
      ) : (
        <Content>
          <Loading />
        </Content>
      )}
    </Main>
  );
}
